import React, { useRef } from 'react';
import classNames from 'classnames';

import Square from './Square';
import Circle from './Circle';
import Toggle from './Toggle';

const ns = `checkbox`;

const Checkbox = ({
	circle,
	toggle,
	onChange = () => {},
	...props
}) => {
	const checkboxRef = useRef();

	const handleChange = e => {
		onChange(e);
	};

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--checked`]: props.checked,
		[`${ ns }--disabled`]: props.disabled,
		[`${ ns }--circle`]: circle,
		[`${ ns }--toggle`]: toggle,
	});

	const componentProps = {
		...props,
		rootClassnames,
		handleChange,
		checkboxRef,
	};

	if (circle) return <Circle {...componentProps} />;
	if (toggle) return <Toggle {...componentProps} />;

	return <Square {...componentProps} />;
};

export default Checkbox;
